module.exports = __webpack_public_path__ + "img/customer.ee5a2151.webp";